var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.item.columns),function(_item){return _c('div',{key:_item.uuid,staticClass:"col-xs-12 col-sm-6 col-lg-3"},[_c('sb-render',{staticClass:"box",attrs:{"item":_item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }